import { ca } from '@cian/analytics';

type TModalAction = 'Show' | 'Close' | 'Scroll';

export interface ITrackCompareBannerProps {
  action: 'show_sopr' | 'click_sopr';
}

interface ITrackScrollCompareModalProps {
  pageId: number;
}

interface ITrackCompareModalEventProps {
  action: TModalAction;
  label: 'description_modal' | 'pages';
  pageId?: number;
}

function trackCompareModalEvent({ action, label, pageId }: ITrackCompareModalEventProps): void {
  ca('eventSite', {
    action,
    label,
    name: 'oldevent',
    category: 'CompareJKPromo',
    page: {
      ...(pageId === undefined ? {} : { extra: { page_number: pageId } }),
    },
  });
}

export function trackCompareBanner({ action }: ITrackCompareBannerProps): void {
  ca('eventSite', {
    action,
    label: 'newbuilding_compare_jk_promo_banner',
    name: 'oldevent',
    category: 'trap',
    page: {
      extra: {
        trap_type: 'CompareJKPromo',
        bannerName: 'Сравнение ЖК',
        trapid: 'Сравнение ЖК',
      },
    },
  });
}

export function trackShowCompareModal(): void {
  trackCompareModalEvent({ action: 'Show', label: 'description_modal' });
}

export function trackCloseCompareModal(): void {
  trackCompareModalEvent({ action: 'Close', label: 'pages' });
}

export function trackScrollCompareModal({ pageId }: ITrackScrollCompareModalProps): void {
  trackCompareModalEvent({ action: 'Scroll', label: 'pages', pageId });
}

/**
 * Тултип флайта «Сравнение ЖК» у кнопки сравнения в карточке ЖК на выдаче.
 */
function trackCompareFlightTooltipEvent(action: 'Show' | 'Click', label: string): void {
  ca('eventSite', {
    action,
    label,
    name: 'oldevent',
    category: 'CompareJKPromo',
  });
}

export function trackCompareFlightTooltipShow(): void {
  trackCompareFlightTooltipEvent('Show', 'tooltip');
}

export function trackCompareFlightTooltipAboutClick(): void {
  trackCompareFlightTooltipEvent('Click', 'tooltip_about_link');
}
